import { OneCache } from 'fetchye-one-app';
import combineReducers from './combineImmutableReducers';
import privacyReducer from './privacy/reducer';
const fetchyeCache = OneCache();
export default combineReducers({
  privacy: privacyReducer,
  fetchye: fetchyeCache.reducer
});